import React from "react"

import classNames from "src/classNames"

export type AvatarProps = {
  src: string
  alt: string
  size?: "small" | "medium" | "large"
}

const Avatar: React.FC<AvatarProps> = ({ src, alt, size = "small" }) => {
  let sizeClassNames
  switch (size) {
    case "small":
      sizeClassNames = "h-8 w-8"
      break
    case "medium":
      sizeClassNames = "h-16 w-16"
      break
    case "large":
      sizeClassNames = "h-24 w-24"
      break
  }

  return (
    <img
      className={classNames(
        "rounded-full bg-white object-cover outline outline-gray-300",
        sizeClassNames
      )}
      src={src}
      alt={alt}
    />
  )
}

export default Avatar
